export default __webpack_public_path__ + "static/zoom-f84615df91e08aac43a7ff299403dfe7.png";